var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCennz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.323 9.558H4.437V8.49H3.21v4.18h1.227V11.32h1.886v1.853c0 .428-.545.807-.817.943-.797.032-2.534.076-3.113 0-.578-.075-1.142-.66-1.351-.943-.032-1.205-.076-3.829 0-4.684.075-.856.765-1.237 1.1-1.32.933-.085 2.91-.252 3.364-.252.452 0 .733.691.817 1.037v1.603z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.918 7.955 9.31 8.27v1.54h1.917v1.634H9.215l.094 1.54h2.388v1.667l-4.495-.314V6.73l4.715-.378v1.603z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.767 6.352v8.456l1.635.157V10.47l1.729 4.684 2.484.314V5.786l-1.854.22v5.313l-1.667-5.157-2.326.189z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.192 15.468H19.62V5.786l2.2-.283 1.824 5.941v-5.94l1.76-.253v10.721l-2.483-.219-1.602-5.375-.126 5.093z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m31 16.411-4.778-.439v-2.294l2.577-6.287h-2.578V5.25L31 5.001v2.232l-2.515 6.727H31v2.451z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.51 18.737v6.445l1.918-.22v-6.036H31v-1.54l-5.061-.472v1.666l1.57.157z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.09 16.726v1.634h-2.578v1.886H24.4v1.635l-1.888.19v1.634h2.578v1.666l-4.62.41V16.41l4.62.316z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m17.042 25.968 2.578-.189V16.41l-1.76-.282-.157 5.942-1.76-6.099-2.296-.219v10.532h1.76v-5.218l1.635 4.904z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCennz);
export default __webpack_public_path__ + "static/media/CENNZ.adf231b71c51006feab8390a5bfe69ea.svg";
export { ForwardRef as ReactComponent };